import { memo } from "react";

import RadioButton from "../RadioComponent";

import styles from "./styles.module.scss";

const FeedbackForm = (props) => {
  const { questionsList, handleQuestionAnswer, answered } = props;

  return (
    <>
      {questionsList?.map((question) => (
        <div key={question?.assQuestionId} className={styles["question-card"]}>
          <p className={styles["question-title"]}>{question?.question}</p>

          <div className={styles["option-wrapper"]}>
            {question?.answers?.map((option) => (
              <RadioButton
                key={option?.assAnswerId}
                name={`question-${question?.assQuestionId}`}
                label={option?.answer}
                checked={answered[question?.assQuestionId] === option?.assAnswerId}
                onChange={() =>
                  handleQuestionAnswer(question?.assQuestionId, option?.assAnswerId)
                }
              />
            ))}
          </div>
        </div>
      ))}
    </>
  );
};

export default memo(FeedbackForm);
